import api from "src/apis/api"

export async function fetchPipelines(entityType) {
  const params = entityType ? `?entity_type=${entityType}` : ""
  const { data } = await api.get(`/api/v1/pipelines${params}`)
  return data.pipelines || []
}

export async function fetchPipeline(id) {
  const { data } = await api.get(`/api/v1/pipelines/${id}`)
  return data.pipeline
}

export async function createPipeline(payload) {
  const { data } = await api.post("/api/v1/pipelines", { pipeline: payload })
  return data.pipeline
}

export async function updatePipeline(id, payload) {
  const { data } = await api.patch(`/api/v1/pipelines/${id}`, { pipeline: payload })
  return data.pipeline
}

export async function deletePipeline(id) {
  await api.delete(`/api/v1/pipelines/${id}`)
}

export async function activatePipeline(id) {
  const { data } = await api.post(`/api/v1/pipelines/${id}/activate`)
  return data.pipeline
}

// ── Stages ──────────────────────────────────────────────────────────────────

export async function createStage(pipelineId, payload) {
  const { data } = await api.post(`/api/v1/pipelines/${pipelineId}/stages`, { stage: payload })
  return data.stage
}

export async function updateStage(pipelineId, stageId, payload) {
  const { data } = await api.patch(`/api/v1/pipelines/${pipelineId}/stages/${stageId}`, { stage: payload })
  return data.stage
}

export async function deleteStage(pipelineId, stageId) {
  await api.delete(`/api/v1/pipelines/${pipelineId}/stages/${stageId}`)
}

export async function reorderStages(pipelineId, orderedIds) {
  const { data } = await api.post(`/api/v1/pipelines/${pipelineId}/stages/reorder`, { order: orderedIds })
  return data.stages
}

// ── Lead Statuses (from active lead pipeline) ───────────────────────────────

export async function fetchLeadStatuses() {
  const { data } = await api.get("/api/v1/pipelines/lead_statuses")
  return data
}
